module.exports = __webpack_public_path__ + "img/enterprise_btn1.f3545815.png";